import React from "react";

export default function(props) {
  return (
    <span className={'sprite flag_' + (props.size || 48) + '_' + props.flagIso}></span>
  );
};
